import axios from 'axios';
import { change } from 'redux-form';
import { browserHistory } from 'react-router';

import {
  REQUEST_DASHBOARD_MESSAGES,
  FETCH_DASHBOARD_MESSAGES_SUCCESS,
  FETCH_DASHBOARD_MESSAGES_FAILURE,
  POST_DASHBOARD_MESSAGE,
  POST_MESSAGE_SUCCESS,
  POST_MESSAGE_FAILURE,
  REQUEST_CONSOLIDATED_STATISTICS,
  FETCH_CONSOLODATED_STATISTICS_SUCCESS,
  FETCH_CONSOLODATED_STATISTICS_FAILURE,
} from './type';

import {
  MESSAGE_DASHBOARD_URL,
  CONSOLODATED_STATISTICS_URL
} from './url';

import { DEFAULT_ERROR } from '../components/Common/constants';
import { getFromToDates } from '../components/Common/cleanDates';
import { isGGI } from './root_url'

export function fetchDashboardMessages(company) {
  return dispatch => {
    dispatch({ type: REQUEST_DASHBOARD_MESSAGES });
    return axios.get(MESSAGE_DASHBOARD_URL,
    // return axios.get(MESSAGE_DASHBOARD_URL + '?Company_id=' + company,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
      })
      .then(response => {
        dispatch(fetchDashboardMessagesSuccess(response));
      }, err => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
          document.getElementById('tokenInvalid').style.display = 'flex'
        } else {
          dispatch(fetchDashboardMessagesFailure(err));
        }
      });
  };
}

function fetchDashboardMessagesSuccess(messages) {
  return {
    type: FETCH_DASHBOARD_MESSAGES_SUCCESS,
    payload: messages
  };
}

function fetchDashboardMessagesFailure(error) {
  return {
    type: FETCH_DASHBOARD_MESSAGES_FAILURE,
    payload: error
  };
}

export function postDashboardMessage(Message, Color, Quote_id) {
  return dispatch => {
    dispatch({ type: POST_DASHBOARD_MESSAGE });
    return axios.post(MESSAGE_DASHBOARD_URL,
    {
      Message: Message.message,
      Color,
      Quote_id,
    },
    {
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
    })
    .then(response => {
      dispatch(postDashboardMessageSuccess(response));
      dispatch(change('generalDashboard', 'MessageField', ''));
    }, err => {
      if (err.status === 500 || err.status === 404) {
        err.data = DEFAULT_ERROR;
      }
      if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
        document.getElementById('tokenInvalid').style.display = 'flex'
      } else {
        dispatch(postDashboardMessageFailure(err));
      }
      console.log('error found', err);
    });
  };
}

function postDashboardMessageSuccess(messages) {
  return {
    type: POST_MESSAGE_SUCCESS,
    payload: messages
  };
}

function postDashboardMessageFailure(error) {
  return {
    type: POST_MESSAGE_FAILURE,
    payloard: error
  };
}

export function fetchConsolidatedStatistics(from, to) {
  const fromDate = moment(from).startOf('day').toISOString();
  const toDate = moment(to).endOf('day').toISOString();
  return (dispatch) => {
    dispatch({ type: REQUEST_CONSOLIDATED_STATISTICS });
    return axios({
      method: 'get',
      url: CONSOLODATED_STATISTICS_URL,
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      params: {
        start_date: fromDate,
        end_date: toDate,
      },
    }).then((response) => {
      dispatch(fetchConsolidatedStatisticsSuccess(response));
    }, (err) => {
      if (err.status === 500 || err.status === 404) {
        err.data = DEFAULT_ERROR;
      }
      if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
        document.getElementById('tokenInvalid').style.display = 'flex'
      } else {
        dispatch(fetchConsolidatedStatisticsFailure(err));
      }
    });
  };
}

function fetchConsolidatedStatisticsSuccess(messages) {
  return {
    type: FETCH_CONSOLODATED_STATISTICS_SUCCESS,
    payload: messages
  };
}

function fetchConsolidatedStatisticsFailure(error) {
  return {
    type: FETCH_CONSOLODATED_STATISTICS_FAILURE,
    payload: error
  };
}

export function setField(form, field, value) {
  return (dispatch) => {
    dispatch(change(form, field, value));
  };
}



// WEBPACK FOOTER //
// ./master/jsx/actions/dashboard_actions.jsx